import React, { useState } from "react";
import { GoogleLogo } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import TigerLogo from "@/components/TigerLogo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [starting, setStarting] = useState(false);

  const startLogin = () => {
    if (starting) return;
    setStarting(true);
    const redirectUrl = window.location.origin + "/triage";
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const authUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    // Clear the Google browser session (silently) so Google always re-prompts
    // for the password on the next login. Fallback: proceed anyway after 1200ms.
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = "https://accounts.google.com/Logout";
    const go = () => { try { document.body.removeChild(iframe); } catch (_) {} window.location.href = authUrl; };
    const timer = setTimeout(go, 1200);
    iframe.onload = () => { clearTimeout(timer); setTimeout(go, 200); };
    iframe.onerror = () => { clearTimeout(timer); go(); };
    document.body.appendChild(iframe);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:block relative bg-gradient-to-br from-orange-500 via-amber-500 to-yellow-500">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, white 1px, transparent 2px), radial-gradient(circle at 80% 60%, white 1px, transparent 2px)", backgroundSize: "40px 40px" }} />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-4">
            <TigerLogo size={56} className="shadow-2xl shadow-orange-900/30" />
            <div>
              <div className="font-heading text-2xl font-semibold">@Tiger Professional</div>
              <div className="text-sm opacity-90 tracking-widest uppercase">Modulo Formativo · v.23.0</div>
            </div>
          </div>
          <div>
            <div className="font-heading text-4xl leading-tight mb-4">
              Simulazione didattica del triage infermieristico.
            </div>
            <p className="text-sm opacity-90 max-w-md">
              Strumento formativo e informativo. Non e un dispositivo medico e non e
              destinato all'uso clinico reale in Pronto Soccorso.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="mb-8 lg:hidden flex items-center gap-3">
            <TigerLogo size={40} />
            <div className="font-heading text-xl font-semibold">@Tiger Professional</div>
          </div>
          <h1 className="font-heading text-3xl font-semibold mb-2">Accedi</h1>
          <p className="text-sm text-slate-600 mb-8">
            Accedi con il tuo account Google per usare la simulazione didattica.
          </p>
          <Button
            data-testid="google-login-button"
            onClick={startLogin}
            disabled={starting}
            className="w-full min-h-[52px] text-base bg-slate-900 hover:bg-slate-800"
          >
            <GoogleLogo size={20} weight="bold" className="mr-2" />
            {starting ? "Reindirizzamento…" : "Accedi con Google"}
          </Button>
          <p className="text-xs text-slate-500 mt-3 leading-relaxed">
            Per sicurezza, Google richiederà sempre la password: la sessione precedente nel browser viene chiusa automaticamente.
          </p>
          <p className="text-xs text-slate-500 mt-4 leading-relaxed">
            Accedendo accetti di utilizzare @Tiger Professional esclusivamente per finalita
            didattiche e formative. Il modulo non e un dispositivo medico e non e destinato
            all'uso clinico reale.
          </p>
        </div>
      </div>
    </div>
  );
}
